// extracted by mini-css-extract-plugin
module.exports = {"item":"inventory-form_item___2QPR","active":"inventory-form_active__3qUD-","image":"inventory-form_image__MxcOe","description":"inventory-form_description__1trZi"};